import { Navbar } from "@/projects/FinEaseHomeAndAdmin/pages/FinEaseHomePage/Navbar";
import HeroSection from "./hero-section";
import PensionCalculator from "./pension-calculator";
import WhoCanRegister from "./who-can-register";
import RetirementPlan from "./retirement-plan";
import BlogSection from "./blog-section";
import FAQSection from "./faq-section";
import Footer from "./footer";
import { RegistrationDetailsProvider } from "@/projects/NPS/Stepper/context/registrationDetails";

const Home = () => {
  return (
    <RegistrationDetailsProvider>
      <div className="min-h-full bg-background">
        <Navbar />
        <HeroSection />
        {/* <RegistrationStatus /> */}
        <PensionCalculator />
        <WhoCanRegister />
        <RetirementPlan />
        <BlogSection />
        <FAQSection />
        <Footer />
      </div>
    </RegistrationDetailsProvider>
  );
};

export default Home;
